module.exports = __webpack_public_path__ + "static/media/RH-Horizontal-Logo.32bcb03a.svg";